import React from 'react';
import { ReactComponent as TableIcon } from '../assets/images/sidebar/managment.svg';
import { ReactComponent as ShoppersIcon } from '../assets/images/sidebar/shoppersIcon.svg';
import { ReactComponent as Planning } from '../assets/images/sidebar/planning.svg';
import { ReactComponent as Stores } from '../assets/images/sidebar/tiendas.svg';
import { ReactComponent as Slots } from '../assets/images/sidebar/slots.svg';
import { ReactComponent as Performance } from '../assets/images/sidebar/performance.svg';
import { ReactComponent as Missions } from '../assets/images/sidebar/misiones.svg';
import { ReactComponent as Training } from '../assets/images/sidebar/administrador-cursos.svg';

const components = {
  Dashboard: {
    component: 'Dashboard',
    url: '',
    title: 'Components.Dashboard.Home',
    icon: '',
    noDisplay: true,
    module: 1,
  },
  Management: {
    component: 'Management',
    url: '/management',
    title: 'Components.Dashboard.ManagmentLive',
    icon: <TableIcon />,
    color: 'LightGreen',
    module: 1,
  },
  Orders: {
    component: 'OrdersSection',
    url: '/management/orders',
    title: 'Components.Dashboard.ManagmentLive',
    icon: 'menu',
    noDisplay: true,
    module: 1,
  },
  Shoppers: {
    component: 'Shoppers',
    url: '/shoppers',
    title: 'Components.Dashboard.Shoppers',
    color: 'Green',
    icon: <ShoppersIcon />,
    module: 1,
  },
  Planning: {
    component: 'PlanningSection',
    url: '/planning',
    title: 'Components.Dashboard.Planning',
    icon: <Planning />,
    color: 'LightBlue',
    module: 1,
  },
  Calendar: {
    component: 'CalendarPlanning',
    url: '/planning/calendar',
    title: 'Components.Dashboard.Planning',
    icon: 'menu',
    noDisplay: true,
    color: 'LightBlue',
    module: 1,
  },
  Stores: {
    component: 'StoresSection',
    url: '/stores',
    title: 'Components.Dashboard.Stores',
    icon: <Stores />,
    color: 'Blue',
    module: 1,
  },
  Slots: {
    component: 'Slots',
    url: '/slots',
    title: 'Components.Dashboard.Slots',
    icon: <Slots />,
    color: 'DarkBlue',
    module: 1,
  },
  Admin: {
    component: 'Admin',
    url: '/admin',
    title: 'Components.Dashboard.Admin',
    icon: <ShoppersIcon />,
    color: 'DarkBlue',
    module: 1,
  },
  Performance: {
    component: 'PerformanceVelocitySection',
    url: '/performance-velocity',
    title: 'Components.Dashboard.Performance',
    icon: <Performance />,
    color: 'LightGreen',
    module: 1,
  },
  Service: {
    component: 'PerformanceServiceSection',
    url: '/performance-service',
    title: 'Components.Dashboard.Performance',
    icon: 'menu',
    noDisplay: true,
    color: 'LightBlue',
    module: 1,
  },
  Missions: {
    component: 'MissionsSection',
    url: '/missions',
    title: 'Components.Missions.Missions',
    icon: <Missions />,
    color: 'LightBlue',
    module: 1,
  },
  Training: {
    component: 'TrainingSection',
    url: '/courses',
    title: 'Components.Courses.Training',
    icon: <Training />,
    color: 'Blue',
    module: 1,
    children: [{
      component: 'TrainingShoppersList',
      url: '/courses/detail',
      title: 'Components.Courses.Training',
      noDisplay: true,
    }],
  },
  Events: {
    component: 'EventsSection',
    url: '/events',
    title: 'Components.Events.Title',
    noDisplay: true,
  },
  Alarms: {
    component: 'Alarms',
    url: '/alarms',
    title: 'Components.Alarms.Title',
    icon: <Missions />,
    color: 'Blue',
    module: 1,
  },
  Capacity: {
    component: 'CapacitySection',
    url: '/capacity',
    title: 'Components.Capacity.Title',
    icon: <ShoppersIcon />,
    color: 'DarkBlue',
    module: 1,
  },
};

// modules for grouping.
const modules = {
  0: {
    title: 'Dashboard',
    icon: 'home',
    isExpendable: true,
    isVisible: true,
  },
};

// component's access to roles.
const rolesConfig = {
  admin: {
    routes: [...Object.values(components)],
  },
  manager: {
    routes: [
      components.dashboard,
    ],
  },
  user: {
    routes: [
      {
        component: 'Dashboard',
        url: '',
        title: 'Components.Dashboard.Home',
        icon: '',
        noDisplay: true,
        module: 1,
        permissions: ['read'],
      },
      {
        component: 'Management',
        url: '/management',
        title: 'Components.Dashboard.ManagmentLive',
        icon: <TableIcon />,
        color: 'LightGreen',
        module: 1,
        permissions: ['read'],
      },
      {
        component: 'OrdersSection',
        url: '/management/orders',
        title: 'Components.Dashboard.ManagmentLive',
        icon: 'menu',
        noDisplay: true,
        module: 1,
        permissions: ['read'],
      },
      {
        component: 'Shoppers',
        url: '/shoppers',
        title: 'Components.Dashboard.Shoppers',
        color: 'Green',
        icon: <ShoppersIcon />,
        module: 1,
        permissions: ['read'],
      },
      {
        component: 'PlanningSection',
        url: '/planning',
        title: 'Components.Dashboard.Planning',
        icon: <Planning />,
        color: 'LightBlue',
        module: 1,
        permissions: ['read'],
      },
      {
        component: 'CalendarPlanning',
        url: '/planning/calendar',
        title: 'Components.Dashboard.Planning',
        icon: 'menu',
        noDisplay: true,
        color: 'LightBlue',
        module: 1,
        permissions: ['read'],
      },
      {
        component: 'StoresSection',
        url: '/stores',
        title: 'Components.Dashboard.Stores',
        icon: <Stores />,
        color: 'Blue',
        module: 1,
        permissions: ['read'],
      },
      {
        component: 'Slots',
        url: '/slots?type=rt',
        title: 'Components.Dashboard.Slots',
        icon: <Stores />,
        color: 'DarkBlue',
        module: 1,
        permissions: ['read'],
      },
    ],
  },
};

const shareParams = {
  Management: {
    Orders: {
      supervisor_id: true,
      shopper_id: true,
      store_id: true,
      store_name: true,
    },
  },
  Orders: {
    Management: {
      supervisor_id: true,
      shopper_id: true,
      store_id: true,
      store_name: true,
    },
  },
  Planning: {
    Calendar: {
      supervisor_id: true,
      shopper_id: true,
      store_id: true,
    },
  },
  Calendar: {
    Planning: {
      supervisor_id: true,
      shopper_id: true,
      store_id: true,
    },
  },
};

const ROLES = {
  SUPERVISOR: 'supervisor',
  ADMINISTRATOR: 'admin',
  USER: 'user',
};

export {
  modules, rolesConfig, shareParams, components, ROLES,
};
